// extracted by mini-css-extract-plugin
export default {"container":"sJ-z","error":"tJ-z","disabled":"uJ-z","submit":"vJ-z","option":"wJ-z","success":"xJ-z","failure":"yJ-z"};